import {environmentConfig} from "@/config/enviromentConfig";
import axios from "axios";
import {Cloud7ServiceIds} from "@/config";

const headers = {Authorization: `Basic ${environmentConfig.authHeader}`};

export default class Cloud7Service {
    static async checkout(msisdn) {
        return await axios.post(`${environmentConfig.cloud7Host}/checkout`, {
                msisdn,
                serviceId: Cloud7ServiceIds.daily,
                channel: 'Others',
                paymentSuccessRedirectUrl: `https://cricketzone.co.za.club?msisdn=${msisdn}`,
                paymentFailedRedirectUrl: `https://bd-gp-cricketzone-club.migration.penrosesystems.com?msisdn=${msisdn}`,
                paymentDenyRedirectUrl: `https://bd-gp-cricketzone-club.migration.penrosesystems.com?msisdn=${msisdn}`,
            }, {headers}
        )
    }

    static async getUser(msisdn, productId) {
        return await axios.post(`${environmentConfig.cloud7Host}/get-user`, {
            msisdn,
            productId
        }, {headers})
    }

}
